import React from 'react';
import { SingleSelect } from '~/components';

const options = [
  { id: 'employee', name: 'Employee' },
  { id: 'contractor', name: 'Contractor' },
  { id: 'other', name: 'Other' },
];

export default function MemberTypeSelect({ name, value, onChange, disabled, placeholder = 'Member Type' }) {
  return (
    <SingleSelect name={name} placeholder={placeholder} disabled={disabled} value={value} onChange={onChange}>
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </SingleSelect>
  );
}
